// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"f57c2b23","154":"33e12d65","241":"f1227ca0","244":"aec12a1d","326":"d333c244","366":"4cea812e","446":"eb5da708","598":"ecb6aa52","676":"b35484cd","791":"d6fdabc1","812":"c7c6462d","928":"c378fb97","953":"d63601e5","962":"c06c7710","971":"808c281a"}[chunkId] + ".chunk.js";
};